module.exports = __webpack_public_path__ + "Ico_save.png";